import GearIcon from "../../../svg/GearIcon.vue";
import GroupIcon from "../../../svg/GroupIcon.vue";
import ChartsIcon from "../../../svg/ChartsIcon.vue";
import type { Component } from "vue";

type TProviderCardIcon = "targeted-audience" | "gear" | "revenue";

export type TProviderCard = {
    id: number;
    icon: TProviderCardIcon;
    title: string;
    description: string;
}

export const BECOME_A_PROVIDER_CARDS: TProviderCard[] = [
    {
        id: 1,
        icon: "targeted-audience",
        title: "Targeted Audience",
        description: "Reach thousands of compliance professionals and financial institutions actively seeking high-quality training",
    },
    {
        id: 2,
        icon: "gear",
        title: "Easy Publishing Tools",
        description: "Upload content, manage updates, and track performance with our intuitive course management system"
    },
    {
        id: 3,
        icon:"revenue",
        title: "Revenue Opportunities",
        description: "Get paid for every enrollment and build long-term relationships with enterprise clients",
    }
] as const;

export const BECOME_A_COURSE_PROVIDER_ICONS: Record<TProviderCardIcon, Component> = {
    "targeted-audience": GroupIcon,
    "gear": GearIcon,
    "revenue": ChartsIcon,
} as const;

